"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisitDetails = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const VisitDetails = _ref => {
  let {
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 48"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M31.868 0c2.865 0 5.209 2.28 5.327 5.126l.005.226v37.296c0 2.876-2.271 5.228-5.107 5.347l-.225.005H5.331C2.467 48 .123 45.72.005 42.874L0 42.648V5.352C0 2.476 2.27.123 5.106.005L5.33 0h26.537Zm0 2.18H5.331a3.17 3.17 0 0 0-3.155 2.986l-.006.186v37.296a3.172 3.172 0 0 0 2.975 3.167l.186.006h26.537a3.17 3.17 0 0 0 3.156-2.987l.006-.186V5.352l-.006-.186a3.172 3.172 0 0 0-2.97-2.981l-.186-.006ZM17.193 22.8H20c.736 0 1.334-.596 1.336-1.332V18.94h2.528c.738 0 1.336-.598 1.336-1.335v-2.806c0-.738-.598-1.336-1.336-1.336h-2.528v-2.528c0-.735-.594-1.331-1.329-1.335H17.2c-.738 0-1.336.598-1.336 1.335v2.528h-2.528c-.738 0-1.336.598-1.336 1.336v2.806c0 .737.598 1.335 1.336 1.335h2.521v2.525c0 .737.598 1.335 1.336 1.335ZM27.235 28H10.898c-.495 0-.898.478-.898 1.067 0 .588.403 1.066.899 1.066h16.336c.495 0 .898-.478.898-1.066 0-.589-.403-1.067-.898-1.067Zm0 5.333H10.898c-.495 0-.898.479-.898 1.067s.403 1.067.899 1.067h16.336c.495 0 .898-.479.898-1.067s-.403-1.067-.898-1.067Zm-9.9-12.733h2.33v-2.735c0-.331.268-.6.6-.6H23v-2.33h-2.735a.601.601 0 0 1-.6-.6V11.6h-2.33v2.735c0 .331-.268.6-.6.6H14v2.33h2.735c.332 0 .6.268.6.6V20.6Z",
    clipRule: "evenodd"
  }));
};
exports.VisitDetails = VisitDetails;
VisitDetails.displayName = "VisitDetails";